/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

const trackClick = function(link) {
  let text;
  const $link = $(link);
  let type = "";
  if ($link.is('input[type="submit"]')) {
    type = "Submit";
    const $form = $link.parents('form');
    const form_id = $form.prop('id');
    if (form_id !== undefined) {
      text = titleCase(form_id.replace(/_/g, ' '));
    } else {
      text = presence($link.prop('value')) || presence($link.prop('id')) || presence($link.prop('class'));
    }
  } else if ($link.is('.button') || $link.is('button')) {
    type = "Button";
  } else {
    type = "Link";
  }
  if (!text) { text = presence($link.text()) || presence($link.prop('id')) || presence($link.prop('class')); }

  track(type, "Clicked",  text, {} );
  return true;
};

root.initTrackClicks = () => $('body').find('a, .submit, .button').click(function() {
  return trackClick(this);
});

root.track = (category, event, label, options) => (typeof analytics !== 'undefined' && analytics !== null) && analytics.track(event, $.extend({ category, label }, options || []));

let analyticsInitialized = false;
root.initAnalytics = function() {
    if (analyticsInitialized || !$ || !window.analytics) { return; }
    analyticsInitialized = true;

    const $body = $('body');
    const category = $body.data('category');
    const title = $body.data('title') || $('head title').text();
    let properties = $body.data('properties') || {};
    if ($.type(properties) === "string") { properties = JSON.parse(properties); }

    if (presence(category)) {
      return analytics.page(category, title, properties);
    } else if (presence(title)) {
      return analytics.page(title, properties);
    } else {
      return analytics.page(properties);
    }
  };

$(() => // If window.analytics is not defined yet, it will run initAnalytics when it is defined
initAnalytics());

